import { css } from 'styled-components';

export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const currentBreakpoint = (width) =>
  Object.keys(BREAKPOINTS).reduce((acc, label) => {
    if (width >= BREAKPOINTS[label]) {
      return label;
    }

    return acc;
  });

export default Object.keys(BREAKPOINTS).reduce((acc, label) => {
  const size = BREAKPOINTS[label];

  acc[label] = (...args) => css`
    @media (min-width: ${size}px) {
      ${css(...args)};
    }
  `;

  return acc;
}, {});
